import '../../Components/Page/Page.css'
import SecHeader from '../../Components/SecHeader/SecHeader';
import '../../Content/Software/Software.css';


const HighROI: React.FC = () => {
    return (
        <div className='software'>
            <SecHeader title="High ROIs" />
            <div className="description">
                <p>
                    <div>
                        <b>High Dividends​</b>
                        <br />• Our low overheld licensing plus in-house testing 
                        and products production give high dividends
                        <br />• U.S. Section 1202 Economic Development Tax Incentive 
                        (new since 2024) may make our dividends Tax free !
                        <br/>• We are predicted to give shareholders their investment 
                        amounts or more in dividends in the next 5-6 years
                        <br/>
                    </div>
                    <div>
                        <b>Strong Valuation ROIs + Multiple Exits​</b>
                        <br />• Valuation ROIs (10-yr.) should be 10:1 to 25:1 or more
                        <br />• We have several exit options starting as soon as year-3
                    </div>
                    <div>
                        <b>Information & Control ​</b>
                        <br />• Our shareholders receive exclusive tech, business, and markets information to use to improve their positions
                        ​<br />
                    </div>
                </p>
            </div>
        </div>
    );
};

export default HighROI;